
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAnchorwatch as ObiAnchorwatchElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-anchorwatch.js';
 
 
 

 
 export const ObiAnchorwatch = createComponent({
   react: React,
   tagName: 'obi-anchorwatch',
   elementClass: ObiAnchorwatchElement,
   events: {
     
   }
  });
 
 